import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/home/Home.vue"; 
import Demo from "../views/empresa/demo.vue";
import HomePage from "../home-page.vue";
import LayoupVe from "../layoup-ve.vue";
import Interes from "../views/help/Interes.vue";
import PoliticaPrivacidad from "../views/help/PoliticaPrivacidad.vue";
import LayoupPa from "../layoup-pa.vue";
import HomePa from "../views/home/HomePa.vue";

const routes = [

  {
    path: '/',
    name: 'home',
    meta: { title: "Alliance - Inteligencia contable" },
    component: HomePage // Se carga HomeView
  },

  // RUTA /VE CON RUTAS HIJAS ANIDADAS
  {
    path: '/ve',
    name: 've-layout',
    component: LayoupVe, 
    children: [
      {
        path: "",
        name: "Home",
        meta: { title: "Alliance - Inteligencia contable" },
        component: Home
      },
      {
        path: "Interes",
        name: "ve-Frequently asked questions",
        meta: { title: "Interes" },
        component: Interes
      },
      {
        path: "crear_cuenta",
        name: "ve-Crear cuenta",
        meta: { title: "Crear cuenta" },
        component: Demo
      },
      {
        path: "politica-privacidad",
        name: "ve-PoliticaPrivacidad",
        meta: { title: "Política de Privacidad - Alliance" },
        component: PoliticaPrivacidad
      }
    ]
  }, 
  {
    path: '/pa',
    name: 'pa-layout',
    component: LayoupPa, 
    children: [
      {
        path: "",
        name: "Home-Pa",
        meta: { title: "Alliance - Inteligencia contable" },
        component: HomePa
      },
      {
        path: "Interes",
        name: "pa-Frequently asked questions",
        meta: { title: "Interes" },
        component: Interes
      },
      {
        path: "crear_cuenta",
        name: "pa-Crear cuenta",
        meta: { title: "Crear cuenta" },
        component: Demo
      },
      {
        path: "politica-privacidad",
        name: "pa-PoliticaPrivacidad",
        meta: { title: "Política de Privacidad - Alliance" },
        component: PoliticaPrivacidad
      }
    ]
  }   
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title}`;
  next();
});

export default router;
